import React from "react";
import {useSelector} from "react-redux";
import {useParams} from "react-router";
import {useSubscription} from "../../subscription/useSubscription";
import PageSection from "../../elements/PageSection";
import CompanyWithinPortfolioLink from "../company/CompanyWithinPortfolioLink";
import {PortfolioHeader} from "./PortfolioHeader";
import GroupingsLayout from "../grouping/GroupingsLayout";
import KpiChooser from "../kpi/KpiChooser";
import OurProgrammeContext, {subscriptionUrl} from "../navigation/OurProgrammeContext";
import {CentredLoader} from "../../elements/Loader";

const PortfolioPage = ({}) => {
    const params = useParams();
    useSubscription("PORTFOLIO_HEALTH", subscriptionUrl(params), 60);
    const portfolioHealth = useSelector(state => state.portfolioHealth);

    if (!(portfolioHealth.settings && params.portfolioId === portfolioHealth.settings.portfolioId)) {
        return <div style={{padding: 20}}><CentredLoader /></div>;
    }

    const {
        settings: {portfolioName, primaryGroup, owns, portfolioCompanyName, currency, rewardPeriod},
        overallGrouping,
        availablePeriods
    } = portfolioHealth;

    const companyRanking = portfolioHealth.groupings ? portfolioHealth.groupings.company.results : [];
    const authorRanking = portfolioHealth.groupings ? portfolioHealth.groupings.author.results : [];

    const ourProgrammeContext = new OurProgrammeContext(params, portfolioName, null, rewardPeriod);

    const companyWithinPortfolioLinkGenerator = (contributorCompanyId, contributorCompanyName, children) => (
        <CompanyWithinPortfolioLink
            ourProgrammeContext={ourProgrammeContext}
            portfolioCompanyName={portfolioCompanyName}
            contributorCompanyId={contributorCompanyId}
            contributorCompanyName={contributorCompanyName}>
            {children}
        </CompanyWithinPortfolioLink>
    );
    const kpiChooser = new KpiChooser(portfolioHealth.settings);

    return (
        <div>
            <PortfolioHeader settings={portfolioHealth.settings}
                             periods={availablePeriods}
                             ourProgrammeContext={ourProgrammeContext}
                             overallGrouping={overallGrouping}
                             selectedKpi={kpiChooser.selectedKpi({isAdditionalGrouping: false})}/>
            <PageSection>
                <GroupingsLayout showAdditionalGroupings={owns}
                                 groupings={portfolioHealth.groupings}
                                 currency={currency}
                                 kpiChooser={kpiChooser}
                                 portfolioId={params.portfolioId}
                                 portfolioName={portfolioName}
                                 authorRanking={authorRanking}
                                 companyRanking={companyRanking}
                                 primaryGroup={primaryGroup}
                                 companyWithinPortfolioLinkGenerator={companyWithinPortfolioLinkGenerator}
                                 getExploreUrlFor={ourProgrammeContext.exploreGroupingHref.bind(ourProgrammeContext)}
                                 getExportUrlFor={ourProgrammeContext.exportGroupingHref.bind(ourProgrammeContext)}
                                 pageName={"PortfolioPage"}
                                 programmeContext={ourProgrammeContext.context()}
                />
            </PageSection>
        </div>
    );
};

export default PortfolioPage;
